import ActionConstants from "../action-constants"
import Action from "./Action";

class CartListModelbActions extends Action {
    static getModelBData(data) {
        return {
            type: ActionConstants.GET_MODEL_B_NAME,
            payload: {
                data
            }
        }
    }
}

export default CartListModelbActions;